import { useEffect, useRef, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { CheckCircle2, XCircle } from "lucide-react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";

const MSG = {
  signing_complete: ["Grazie, firma completata", "Il contratto è stato firmato. Riceverà una copia via email dopo la convalida di Trust Master."],
  decline: ["Firma rifiutata", "Ha scelto di non firmare il contratto. Lo studio la ricontatterà."],
  cancel: ["Firma sospesa", "La firma non è stata completata. Può riprenderla con l'operatore."],
};

export default function SigningDone() {
  const [params] = useSearchParams();
  const { logout } = useAuth();
  const [done, setDone] = useState(false);
  const once = useRef(false);
  const event = params.get("event") || "exception";
  const [title, text] = MSG[event] || ["Sessione di firma terminata", "Restituisca il tablet all'operatore."];

  useEffect(() => {
    if (once.current) return;
    once.current = true;
    const cid = params.get("c");
    (cid ? api.post(`/contracts/${cid}/studio-return`, { event }).catch(() => null) : Promise.resolve())
      .then(() => logout())
      .finally(() => setDone(true));
  }, [params, event, logout]);

  const ok = event === "signing_complete";
  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50 p-6" data-testid="signing-done">
      <div className="max-w-md text-center space-y-5">
        {ok ? <CheckCircle2 className="h-16 w-16 mx-auto text-emerald-600" /> : <XCircle className="h-16 w-16 mx-auto text-slate-400" />}
        <h1 className="font-heading text-3xl sm:text-4xl font-semibold text-slate-900" data-testid="signing-done-title">{title}</h1>
        <p className="text-slate-600">{text}</p>
        <p className="text-sm text-slate-500">Restituisca il tablet all'operatore.</p>
        <Button variant="outline" disabled={!done} onClick={() => window.location.assign("/login")} data-testid="signing-done-operator">Accesso operatore</Button>
      </div>
    </div>
  );
}
